import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Validation Status Overview',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Change Impacts by Validation Status',
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Not Started',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'notStarted',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'Not Started',
                                            },
                                          },
                                          navigationId: 'change.impacts',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'In Progress',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'inProgress',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'In Progress',
                                            },
                                          },
                                          navigationId: 'change.impacts',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Completed',
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'completed',
                                },
                              },
                              0,
                            ],
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'Completed',
                                            },
                                          },
                                          navigationId: 'change.impacts',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    completed: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'Completed',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inProgress: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'In Progress',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    notStarted: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'Not Started',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
